import { createLucideIcon } from 'lucide-react';

// Paths scaled from 16x16 to 24x24 (1.5x)
export const BlurBackgroundIcon = createLucideIcon('BlurBackgroundIcon', [
  [
    'path',
    {
      key: 'path-1',
      d: 'M21 22.5C18.4245 20.6049 15.3294 19.5 12 19.5C8.67059 19.5 5.57542 20.6049 3 22.5',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      fill: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-2',
      d: 'M1.5 9.375L9.375 1.5',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      fill: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-3',
      d: 'M19.5 4.5L22.5 1.5',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      fill: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-4',
      d: 'M19.5 16.3125L22.5 13.3125',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      fill: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-5',
      d: 'M1.5 16.125L3 14.625',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      fill: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-6',
      d: 'M15 2.625L16.5 1.125',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      fill: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-7',
      d: 'M1.5 2.8125L2.8125 1.5',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      fill: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-8',
      d: 'M21.1875 9.375L22.5 8.0625',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      fill: 'none',
    },
  ],
  [
    'circle',
    {
      key: 'circle-1',
      cx: '12',
      cy: '10.6',
      r: '4.5',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: 'none',
    },
  ],
]);
